import { getCurrencies } from 'api/node/currencies';
import { SelectField } from 'components/Fields';
import { useCache } from 'hooks';
import { useMemo } from 'react';
import { useAsync } from 'react-async';
import { formatCurrencyLabel } from 'utils';

const SelectCurrencyField = ({ ...props }) => {
  const { getKey, getData, setData } = useCache();
  const cacheKey = getKey(getCurrencies.name);
  const cachedData = getData(cacheKey);

  const { data: currenciesData } = useAsync({
    promiseFn: !cachedData ? getCurrencies : undefined,
    watch: false,
    onResolve: (response) => {
      setData(cacheKey, response.data);
    },
  });

  const data = cachedData ?? currenciesData?.data;
  const currenciesOptions = useMemo(
    () =>
      (data ?? []).map(({ name: currency }) => ({
        value: currency,
        label: formatCurrencyLabel(currency),
      })),
    [data],
  );

  return (
    <SelectField
      options={currenciesOptions}
      {...props}
      renderSelectedValue={(value) =>
        value?.label || formatCurrencyLabel(value)
      }
    />
  );
};

export default SelectCurrencyField;
